import { useSelector } from "react-redux";

const useAuthToken = () => {
  const token = useSelector((state) => state.user?.token);
  return token.token;
};

export default useAuthToken;
